export default "__VITE_ASSET__CAql$qCI__"